import React, { useEffect, useState } from "react";
import { formateDateTime } from "../../utils";
import Avatar from "../../static/images/pb-icon.png";
import { ChatEvents, MessageType, Roles } from "../../constants";
import { createImageFromInitials } from "../../AgentLogo";
import FileIcon from "../../static/images/icon-file.svg";
import DownloadIcon from "../../static/images/icon-download.svg";
import { TermPlanDetails } from "./PlanDetails";


function JsonTemplate({
    message,
    displayAllOptions,
    GAEvent,
    showPlansComparison,
    regenDoc,
    selectOption,
    contactSupport,
    mainMenu,
    ViewPlanDetails,
    scrollToBottom,
}) {
    
    const [viewMore, setViewMore] = useState(false)
    const content = JSON.parse(message.content);
    useEffect(() => {
        if (content.choices && content.choices.length > 4 && !message.selected) {
            setViewMore(true)
        }
    })
    const selectPlan=()=>{
        window.parent.postMessage({ message: 'Plan Selection.', planSelection: true }, '*');
    }
    // console.log(message.displayAllOptions)
    return (
        <>
            {content.type && content.type.toLowerCase() === MessageType.document ?
                <div className="grop_message">
                    <div onClick={() => regenDoc(content.document.docId)} className="download-policy-message message">
                        <div className="download-policy">
                            <img src={FileIcon} className="icon-file" alt="" /><p>Document</p><img src={DownloadIcon} className="icon-download" alt="" />
                        </div>

                    </div>
                </div>
                : null}

            {content.type && content.type.toLowerCase() === "selection" ?
                <>
                    {content.title ? (
                        <>
                            <div class="grop_message">
                                <div
                                    class="message"
                                    dangerouslySetInnerHTML={{ __html: content.title }}
                                />
                            </div>

                            <img className="grop_message usericon" src={Avatar} alt=""></img>

                        </>
                    ) : null}
                    {message.selected ? null : (
                        <div class="grop_message tabq">

                            {content.choices.map((item1, index) => (
                                <>
                                    {message.displayAllOptions || index < 3 || !viewMore ?
                                        <div onClick={() => selectOption(item1, content.type, message.messageId)} class="question">
                                            {item1.display_value}
                                        </div>
                                        : null}
                                </>
                            ))}
                            {viewMore && !message.displayAllOptions ?

                                <div onClick={() => displayAllOptions(message.messageId)} class="question">
                                    {"View More"}
                                </div>

                                : null}

                        </div>
                    )}
                </>
                : null}
            {content.type && content.type.toLowerCase() === "plan_multi_selection" ?
                <>
                    {content.title ? (
                        <div class="grop_message">
                            <div
                                class="message"
                                dangerouslySetInnerHTML={{ __html: content.title }}
                            />
                        </div>
                    ) : null}

                </>
                : null}
            {content.type && content.type === "planSelection" ?
            <div className="grop_message" onClick={()=>selectPlan()}>
                <div class="message">Click below to buy Insurance
                    <br />
                    <a href={content.redirectionUrl} class="ref-cta btn" target="_blank">
                        Buy Insurance
                        <i class="redirection"></i>
                    </a>
                </div>
            </div>
                : null}


            {content.type && content.type === "list_plans" ?
                <>
                    {content.title ? (
                        <>
                            <div class="grop_message">
                                <div
                                    class="message"
                                    dangerouslySetInnerHTML={{ __html: content.title }}
                                />
                            </div>

                            <img className="grop_message usericon" src={Avatar} alt=""></img>

                        </>
                    ) : null}

                    <TermPlanDetails message={message} ViewPlanDetails={ViewPlanDetails} contactSupport={contactSupport} mainMenu={mainMenu} content={content} selectOption={selectOption} scrollToBottom={scrollToBottom} />

                </>
                : null}
            {content.type && content.type === "CustomerEngage" ?
                <>
                    {message.selected ? null : content.choices.map((item1, index) => (
                        <div class="grop_message tabq" key={item1.key}>
                            <div onClick={() => selectOption(item1, "selection", message.messageId)} className="question " >
                                {item1.display_value}
                            </div>
                        </div>
                    ))}
                </>
                : null}
        </>
    );
}

export default function TermAgentMessage({
    messages,
    agentName,
    displayAllOptions,
    GAEvent,
    showPlansComparison,
    regenDoc,
    selectOption,
    contactSupport,
    mainMenu,
    AgentMsg,
    ViewPlanDetails,
    scrollToBottom
}) {
    return (
        <li class="you">
            {messages.map((item) => (
                <>
                    {item.type.toLowerCase() === "json" ? (
                        <JsonTemplate
                            message={item}
                            displayAllOptions={displayAllOptions}
                            GAEvent={GAEvent}
                            showPlansComparison={showPlansComparison}
                            regenDoc={regenDoc}
                            selectOption={selectOption}
                            contactSupport={contactSupport}
                            mainMenu={mainMenu}
                            AgentMsg={AgentMsg}
                            ViewPlanDetails={ViewPlanDetails}
                            scrollToBottom={scrollToBottom}
                        ></JsonTemplate>
                    ) : (
                        <>
                            <div class="grop_message">
                                <div
                                    class="message"
                                    dangerouslySetInnerHTML={{
                                        __html: item.content,
                                    }}
                                >
                                    {" "}
                                </div>
                            </div>
                            <img className="grop_message usericon" src={Avatar} alt=""></img>

                        </>
                    )}
                </>
            ))}
            {/* <div class="entete">
                <h3>{formateDateTime(messages[messages.length - 1].sentAt)}</h3>
            </div> */}
            {/* <div class="usericon"> 
                    <img src={Avatar} alt=""></img>
            </div> */}
        </li>
    );
}
